function Toast({ toast }) {
  const icons = {
    success: (
      <svg xmlns="http://www.w3.org/2000/svg" width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
        <polyline points="20 6 9 17 4 12" />
      </svg>
    ),
    error: (
      <svg xmlns="http://www.w3.org/2000/svg" width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
        <line x1="18" y1="6" x2="6" y2="18" /><line x1="6" y1="6" x2="18" y2="18" />
      </svg>
    ),
    info: (
      <svg xmlns="http://www.w3.org/2000/svg" width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
        <circle cx="12" cy="12" r="10" /><line x1="12" y1="8" x2="12" y2="12" /><line x1="12" y1="16" x2="12.01" y2="16" />
      </svg>
    ),
  };

  const bg = {
    success: '#211C2B',
    error:   '#FF7A59',
    info:    '#211C2B',
  };

  return (
    <div
      role="status"
      aria-live="polite"
      style={{
        background: bg[toast.type] || bg.info,
        borderRadius: '13px',
        padding: '11px 18px',
        boxShadow: '0 8px 24px rgba(0,0,0,0.28)',
        fontFamily: "'Plus Jakarta Sans', system-ui, sans-serif",
        fontWeight: 600,
      }}
      className={`
        fixed bottom-20 left-1/2 -translate-x-1/2 z-[9999]
        flex items-center gap-2.5
        text-white text-sm max-w-[90vw] text-center
        transition-all duration-[220ms] ease-out
        ${toast.visible ? 'opacity-100 translate-y-0 scale-100' : 'opacity-0 translate-y-4 scale-95 pointer-events-none'}
      `}
    >
      {icons[toast.type] || icons.info}
      {toast.message}
    </div>
  );
}

export default Toast;
